import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { CircularProgress, Grid, Tooltip } from '@mui/material'
import { Button } from '../../../../../../Button'
import useBilling from './useBilling'

const pending = (message) => ({
  message,
  display: 'block',
  color: 'rgb(1, 67, 97)',
  background: 'rgb(229, 246, 253)',
})
const success = (message) => ({
  message,
  display: 'block',
  color: 'rgb(30, 70, 32)',
  background: 'rgb(237, 247, 237)',
})
const failure = (message) => ({
  message,
  display: 'block',
  color: 'rgb(95, 33, 32)',
  background: 'rgb(253, 237, 237)',
})
const view = (message) => ({
  message,
  display: 'block',
  color: 'rgb(102, 60, 0)',
  background: 'rgb(255, 244, 229)',
  border: '1px solid rgb(255, 213, 153)',
})

function SyncShopifyBillingSubscription({ partner, listing }) {
  const [output, setOutput] = useState({ display: 'none' })
  const {
    billingSubscription,
    billingSubscriptionIsLoading,
    billingSubscriptionError,
    syncShopifyBillingSubscription,
  } = useBilling(partner.id, listing.id, partner.sourceKey)

  useEffect(() => {
    if (!billingSubscriptionIsLoading) {
      if (billingSubscriptionError) {
        setOutput(failure('Failed to load billing subscription'))
      } else if (billingSubscription && !billingSubscription.success) {
        setOutput(failure(billingSubscription.errorMessage))
      } else if (billingSubscription) {
        setOutput(view(`Billing Subscription ID: ${billingSubscription.data}`))
      }
    }
  }, [billingSubscription, billingSubscriptionIsLoading, billingSubscriptionError])

  const {
    message, color, background, display,
  } = output
  return (
    <div style={{ borderBottom: '1px dashed #ccc', paddingBottom: '1em' }}>
      <Grid container>
        <Grid item xs={3}>
          <Tooltip
            title={partner.source?.toLowerCase() !== 'shopify' ? 'Only Shopify partners can sync billing' : ''}
            disableHoverListener={partner.source?.toLowerCase() === 'shopify'}
          >
            <span>
              <Button
                label="Sync Billing Subscription"
                variant="contained"
                color="primary"
                disabled={partner.source?.toLowerCase() !== 'shopify'}
                onClick={() => {
                  setOutput(pending('...'))
                  syncShopifyBillingSubscription({
                    billingSubscriptionId: billingSubscription.data ?? 0,
                  }).then((res) => setOutput(res.isSynced
                    ? success(`Billing Subscription Id: ${billingSubscription.data}${res.message ? ` – ${res.message}` : ' - has been updated'}`)
                    : failure(res.errorMessage)))
                }}
              />
            </span>
          </Tooltip>
        </Grid>
        <Grid item xs={9}>
          {billingSubscriptionIsLoading ? (
            <CircularProgress size={20} color="primary" />
          ) : (
            <pre
              style={{
                borderRadius: '5px',
                background,
                color,
                display,
                margin: '0',
                padding: '7px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {message}
            </pre>
          )}
        </Grid>
      </Grid>
    </div>
  )
}

SyncShopifyBillingSubscription.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  partner: PropTypes.shape({
    id: PropTypes.string,
    source: PropTypes.string,
    sourceKey: PropTypes.string,
  }).isRequired,
}

export default SyncShopifyBillingSubscription
